import { useEffect, useState } from "react";
import { authFetch } from "../utils/authFetch";

export default function UserManagement() {

  const [users, setUsers] = useState([]);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [designation, setDesignation] = useState("");



  /* =====================================================
     ADMIN CHECK
  ===================================================== */

  useEffect(() => {

    const user = JSON.parse(
      localStorage.getItem("user")
    );

    if (!user || user.role !== "admin") {

      alert("Access Denied");

      window.location.href = "/dashboard";
    }

    fetchUsers();

  }, []);



  /* =====================================================
     FETCH USERS
  ===================================================== */

  const fetchUsers = async () => {

    try {

      const response = await authFetch(
        `${process.env.REACT_APP_API_URL}/api/auth/users`
      );

      const data = await response.json();

      if (data.success) {

        setUsers(data.users);

      }

    } catch (err) {

      console.log(err);

    }

  };



  /* =====================================================
     CREATE USER
  ===================================================== */

  const createUser = async () => {

    if (
      !name ||
      !email ||
      !password
    ) {

      alert("Fill all fields");

      return;
    }

    try {

      const response = await authFetch(
         `${process.env.REACT_APP_API_URL}/api/auth/create-user`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

         body: JSON.stringify({
  name,
  email,
  password,
  role,
  phone_number: phoneNumber,
  designation,
}),
        }
      );

      const data = await response.json();

      if (data.success) {

        alert("User Created");

        setName("");
        setEmail("");
        setPassword("");
        setRole("purchase");

        fetchUsers();

      } else {

        alert(data.message);

      }

    } catch (err) {

      console.log(err);

      alert("Server Error");

    }

  };



  /* =====================================================
     DELETE USER
  ===================================================== */

  const deleteUser = async (id) => {

    const confirmDelete =
      window.confirm(
        "Delete this user?"
      );

    if (!confirmDelete) return;

    try {

      const response = await authFetch(
       `${process.env.REACT_APP_API_URL}/api/auth/delete-user/${id}`,
        {
          method: "DELETE",
        }
      );

      const data = await response.json();

      if (data.success) {

        alert("User Deleted");

        fetchUsers();

      }

    } catch (err) {

      console.log(err);

      alert("Server Error");

    }

  };



  return (

    <div
  style={{
    padding: "30px",
    color: "#111827",
  }}
>

      {/* HEADER */}

      <div
        style={{
          marginBottom: "30px",
        }}
      >

        <h1
          style={{
            fontSize: "32px",
            marginBottom: "5px",
          }}
        >
          User Management
        </h1>

        <p
          style={{
            color: "#9ca3af",
          }}
        >
          Manage ERP users securely
        </p>

      </div>



      {/* CREATE USER CARD */}

      <div
        style={{
          color: "#111827",
          padding: "25px",
          borderRadius: "16px",
          marginBottom: "30px",
          border: "1px solid #1f2937",
        }}
      >

        <h2
          style={{
            marginBottom: "20px",
          }}
        >
          Create User
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(4,1fr)",
            gap: "15px",
          }}
        >

          <input
            placeholder="Full Name"
            value={name}
            onChange={(e) =>
              setName(e.target.value)
            }
            style={inputStyle}
          />

          <input
            placeholder="Email"
            value={email}
            onChange={(e) =>
              setEmail(e.target.value)
            }
            style={inputStyle}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) =>
              setPassword(e.target.value)
            }
            style={inputStyle}
          />

          <input
  placeholder="Phone Number"
  value={phoneNumber}
  onChange={(e) => setPhoneNumber(e.target.value)}
  style={inputStyle}
/>

<input
  placeholder="Designation"
  value={designation}
  onChange={(e) => setDesignation(e.target.value)}
  style={inputStyle}
/>

          <select
            value={role}
            onChange={(e) =>
              setRole(e.target.value)
            }
            style={inputStyle}
          >
             <option value="">Select Role</option>
            <option value="admin">
              ADMIN
            </option>
            <option value="HOD">
              HEAD OF OPERATION
            </option>
            <option value="purchase">
              PURCHASE TEAM
            </option>
            <option value="accounts">
              ACCOUNTS TEAM
            </option>
            <option value="design">
              DESIGN TEAM
            </option>       
          </select>

        </div>

        <button
          onClick={createUser}
          style={buttonStyle}
        >
          Create User
        </button>

      </div>



      {/* USERS TABLE */}

      <div
        style={{
          background: "#ffffff",
          padding: "25px",
          borderRadius: "16px",
          border: "1px solid #1f2937",
        }}
      >

        <h2
          style={{
            marginBottom: "20px",
          }}
        >
          All Users
        </h2>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >

          <thead>

            <tr
              style={{
                background: "#f3f4f6",
              }}
            >

              <th style={thStyle}>
                Name
              </th>

              <th style={thStyle}>
                Email
              </th>

              <th style={thStyle}>
                Role
              </th>

              <th style={thStyle}>
                Action
              </th>

            </tr>

          </thead>

          <tbody>

            {
              users.map((user) => (

                <tr
                  key={user.id}
                >

                  <td style={tdStyle}>
                    {user.name}
                  </td>

                  <td style={tdStyle}>
                    {user.email}
                  </td>

                  <td style={tdStyle}>
                    {user.role}
                  </td>

                  <td style={tdStyle}>

                    <button
                      onClick={() =>
                        deleteUser(user.id)
                      }
                      style={{
                        background: "#ef4444",
                        border: "none",
                        padding: "8px 14px",
                        borderRadius: "8px",
                        color: "white",
                        cursor: "pointer",
                      }}
                    >
                      Delete
                    </button>

                  </td>

                </tr>

              ))
            }

          </tbody>

        </table>

      </div>

    </div>

  );
}



/* =====================================================
   STYLES
===================================================== */

const inputStyle = {
  width: "100%",
  padding: "14px",
  borderRadius: "10px",
  border: "1px solid #374151",
  background: "#f8fafc",
  color: "black",
  fontSize: "14px",
  outline: "none",
  boxSizing: "border-box",
  boxShadow: "0 2px 10px rgba(27, 20, 20, 0.16)"
};

const buttonStyle = {
  marginTop: "20px",
  background: "#2563eb",
  border: "none",
  padding: "14px 22px",
  borderRadius: "10px",
  color: "white",
  fontWeight: "600",
  cursor: "pointer",
};

const thStyle = {
  padding: "14px",
  textAlign: "left"
};

const tdStyle = {
  padding: "14px",
  borderTop: "1px solid #e5e7eb",
  color: "#111827",
};